var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '@emotion/styled';
import { display, space, position, margin, fontSize, maxWidth, height, color, textAlign, lineHeight, overflow, themeGet, } from 'styled-system';
import { themeTop, themeLeft } from '../theme/system-utilities';
import { breakpoint } from '../theme/helper';
import RichTextBlock from './RichText';
var StoererContainer = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-color: rgba(255, 255, 255, 0.85);\n  border-top: 2px solid\n    ", ";\n  transform: translate(-50%, 0);\n\n  ", " {\n    transform: translate(0);\n  }\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-color: rgba(255, 255, 255, 0.85);\n  border-top: 2px solid\n    ",
    ";\n  transform: translate(-50%, 0);\n\n  ", " {\n    transform: translate(0);\n  }\n"])), display, space, height, textAlign, position, margin, themeTop, themeLeft, color, function (props) {
    return props.borderColor ? props.borderColor : themeGet('colors.brand.normal');
}, breakpoint(0));
StoererContainer.defaultProps = {
    display: 'inline-table',
    position: 'absolute',
    px: '16px',
    margin: ['auto', 0],
    height: '28px',
    textAlign: 'center',
    color: 'gray.10',
};
var StyledRichTextBlock = styled(RichTextBlock)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  white-space: nowrap;\n  text-overflow: clip;\n\n  & p {\n    ", ";\n    ", ";\n  }\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  white-space: nowrap;\n  text-overflow: clip;\n\n  & p {\n    ", ";\n    ", ";\n  }\n"])), display, maxWidth, overflow, fontSize, lineHeight);
StyledRichTextBlock.defaultProps = {
    display: 'inline-flex',
    fontSize: [4, null, null, 5],
    lineHeight: '28px',
    maxWidth: '138px',
    overflow: 'hidden',
};
export var Stoerer = function (_a) {
    var html = _a.label, borderColor = _a.borderColor, themeTopProp = _a.themeTop, themeLeftProp = _a.themeLeft;
    return (React.createElement(StoererContainer, { borderColor: borderColor, themeTop: themeTopProp, themeLeft: themeLeftProp },
        React.createElement(StyledRichTextBlock, { "data-testid": "rich-text-block", dangerouslySetInnerHTML: { __html: html } })));
};
Stoerer.defaultProps = {
    borderColor: null,
    themeTop: 0,
    themeLeft: ['50%', 0],
};
var templateObject_1, templateObject_2;
